// Fixed employee-count buckets for "Tamaño de la empresa" — the DB field stays
// a free-text string (backward compatible with legacy values); this maps the
// known codes to a translated, friendly label everywhere they're displayed.
export const COMPANY_SIZE_OPTIONS = ["1-10", "11-50", "51-200", "201-500", "501-1000", "1000+"];

export const COMPANY_SIZE_LABEL_KEYS = {
  "1-10": "size_1_10", "11-50": "size_11_50", "51-200": "size_51_200",
  "201-500": "size_201_500", "501-1000": "size_501_1000", "1000+": "size_1000_plus",
};

export const companySizeLabel = (size, t) => (size && COMPANY_SIZE_LABEL_KEYS[size] ? t(`company.${COMPANY_SIZE_LABEL_KEYS[size]}`) : size);
